﻿import { Component } from "./Component";

export default Component;
export * from "./Component";
